import React, { useContext } from 'react'

import { useQuery } from '@apollo/client'
import { once } from 'lodash'
import { validate as isUuid } from 'uuid'

import { PaymentMethods } from 'hub/Org/Billing'
import { PAYMENT_METHODS } from 'hub/Org/graphql'

import Section from './Section'
import { logGetStartedEvent } from './log'
import { GetStartedContext, R_START } from './reducer'

const logCreditCardAdded = once(() => logGetStartedEvent('AddCreditCard'))
const logCreditCardSelected = once(() => logGetStartedEvent('SelectCreditCard'))

function GetCard() {
  const [state, dispatch] = useContext(GetStartedContext)
  const orgId = state.orgId

  useQuery(PAYMENT_METHODS, {
    variables: { orgId, skip: !isUuid(orgId) },
    onCompleted({ orgs }) {
      const cards = orgs?.results?.[0]?.paymentMethods
      if (cards?.length > 0) {
        const active = cards.find((m) => m.active)
        if (active && active.id !== state?.card?.id) {
          dispatch({ type: R_START.MERGE, value: { card: active } })
        }
      }
    }
  })

  return (
    <Section heading="Payment Method" className="max-view-page mh1 overflow-auto">
      <PaymentMethods
        orgId={state.orgId}
        embed={true}
        onCardAdd={logCreditCardAdded}
        onCardSelected={logCreditCardSelected}
      />
    </Section>
  )
}

export default GetCard
